// extracted by mini-css-extract-plugin
export default {"headerSec":"blogStyles_headerSec__4ss0u","blogsSec":"blogStyles_blogsSec__NRGod"};